import { Input } from "../Input";
import type { IComboBoxTriggerProps } from "./types";
import { useComboBoxTrigger } from "./useComboBoxTrigger";

export const ComboBoxSingleTrigger = (props: IComboBoxTriggerProps = {}) => {
  const {
    disabled,
    size,
    placeholder,
    inputId,
    searchValue,
    setSearchValue,
    onClear,
    showClearButton,
    invalid,
    loading,
    displayValue,
    open,
    contentId,
    activeDescId,
    onInputKeyDownCapture,
    onInputFocus,
    dataAttributes,
    searchInputRef,
    color,
  } = useComboBoxTrigger();

  const {
    ref: referenceRef,
    onClick,
    onFocus,
    onKeyDown,
    onMouseDown,
    onPointerDown,
    onPointerEnter,
    id: referenceId,
    className,

    role: _role,
    tabIndex: _tabIndex,
    "aria-expanded": _ariaExpanded,
    "aria-haspopup": _ariaHaspopup,
    "aria-controls": _ariaControls,
    "aria-activedescendant": _ariaActiveDescendant,

    ...restReferenceProps
  } = props;

  return (
    <div
      ref={referenceRef}
      id={referenceId}
      className={className ?? "outline-none"}
      onClick={onClick}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onMouseDown={onMouseDown}
      onPointerDown={onPointerDown}
      onPointerEnter={onPointerEnter}
      {...restReferenceProps}
      role={undefined}
      tabIndex={-1}
      aria-haspopup={undefined}
      aria-expanded={undefined}
      aria-controls={undefined}
      aria-activedescendant={undefined}
    >
      <Input
        ref={searchInputRef}
        id={inputId}
        {...dataAttributes}
        role="combobox"
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-controls={contentId}
        aria-autocomplete="list"
        aria-activedescendant={activeDescId}
        size={size}
        value={searchValue || displayValue}
        onChange={setSearchValue}
        onFocus={onInputFocus}
        onKeyDownCapture={onInputKeyDownCapture}
        onClear={showClearButton ? onClear : undefined}
        disabled={disabled}
        invalid={invalid}
        loading={loading}
        placeholder={placeholder}
        autoComplete="off"
        color={color}
      />
    </div>
  );
};
